
$(document).ready(function(){
    setTimeout(function() {
      // Select the button with class 'cart__checkout' and move the specified element after it
      $('.ajaxcart__footer.h_scroll button.btn.cart__checkout').after($('.ajaxcart__footer.h_scroll a.btn.btn-success'));
         console.log("changedd");
    }, 1000); // 1000 milliseconds = 1 second
  });